import { combineReducers } from 'redux';
import * as actions from './scrollreader';
import currentEpisode from './currentEpisodeReducer';
import currentUser from './currentUserReducer';
import deleteConfirmation from './deleteConfirmationReducer';
import episodes from './episodesReducer';
import newCommentForm from './newCommentFormReducer';
import optionsMenu from './optionsMenuReducer';
import poppinForm from './poppinFormReducer';
import reading from './readingReducer';
import recommendedStories from './recommendedStoriesReducer';
import socialControls from './socialControlsReducer';
import signin from './signinReducer';
import story from './storyReducer';
import userLanguagesSettings from './userLanguagesSettingsReducer';

export default combineReducers({
  processing: actions.update_processing_flag,
  episodes_controls_open: actions.episodes_controls_open,
  small_spinner_hidden: actions.small_spinner_hidden,
  current_episode_comments: actions.current_episode_comments,
  reply_form: actions.reply_form,
  update_form: actions.update_form,
  currentEpisode,
  currentUser,
  deleteConfirmation,
  episodes,
  newCommentForm,
  optionsMenu,
  poppinForm,
  reading,
  recommendedStories,
  socialControls,
  signin,
  story,
  userLanguagesSettings
});
